import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';

const PATH = 'api/google-integration/get-redirect-url';

type Response = {
  status: string;
  data: string;
};

export const useGoogleRedirectUrl = (enabled?: boolean) => {
    return useQuery(
        [queryKeys.googleRedirectUrl],
        async () => {
            const res = await apiClient(PATH).json<Response>();
            return res.data;
        },
        { enabled },
    );
};
